import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/certificate';
const serviceName = "ButtonContent-Service: ";

export default class CertificateService {
  static async readFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async updateGuacamole(successF, errorF) {
    await WrapperService.get(API_URL + '/ips/file/update', null, serviceName, successF, errorF)
  }

  static async activateCertificate(certificate, successF, errorF) {
    await WrapperService.put(API_URL + '/activate', certificate, serviceName, successF, errorF)
  }

  static async blockCertificate(certificate, successF, errorF) {
    await WrapperService.put(API_URL + '/revoke', certificate, serviceName, successF, errorF)
  }
}